import { useEffect, useState } from 'react';
import { getCountryLink } from '../data';

export default function WorldMap({ countries, hoveredId, setHoveredId }) {
  const [imgReady, setImgReady] = useState(false);
  const src = process.env.PUBLIC_URL + '/map.svg';

  useEffect(() => {
    const image = new Image();
    image.src = src;
    const finish = () => setImgReady(true);
    if (image.decode) {
      image.decode().then(finish).catch(finish);
    } else {
      image.onload = finish;
      image.onerror = finish;
    }
  }, [src]);

  const hoveredCountry = imgReady
    ? countries.find((country) => country.id === hoveredId)
    : null;

  return (
    <div className="worldmap" style={{ backgroundImage: `url(${src})` }}>

      {imgReady && countries.map((country) => (
        <div
          key={country.id}
          className="pin"
          style={{ top: country.coords.top, left: country.coords.left }}
        >
          <button
            className={`dot ${hoveredId === country.id ? 'dot-active' : ''}`}
            aria-label={country.name}
            onMouseEnter={() => setHoveredId(country.id)}
            onMouseLeave={() => setHoveredId(null)}
          />
        </div>
      ))}

      {imgReady && hoveredCountry && (
        <a
          className="bubble"
          href={getCountryLink(hoveredCountry)}
          target="_parent"
          style={{
            top: `calc(${hoveredCountry.coords.top} + 10px)`,
            left: hoveredCountry.coords.left,
          }}
          onMouseEnter={() => setHoveredId(hoveredCountry.id)}
          onMouseLeave={() => setHoveredId(null)}
        >
          <span className="bubble-title">{hoveredCountry.name}</span>
          <span className="bubble-chev" aria-hidden>›</span>
        </a>
      )}
    </div>
  );
}
